import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_LETTER_TEMPLATES',
    icon: 'BookIcon',
    route: 'letters',
    action: constants.action.permissionLogin,
    resource: constants.resource.user,
  },
]
